import { app } from '@/config/app/app'
import { Layout, HeaderLayout, FooterLayout } from '@/views/Layout'
import { News, NewsDetail, AsideNewsList } from '@/views/News'
import { MainPage } from '@/views/MainPage'
import { CVForm } from '@/views/CVForm'
import { Page404 } from '@/views/Page404'
import { VacanciesPage, VacancyDetail } from '@/views/vacancies/'
import { CareerYouthProgramsPage, CareerYouthProgramsPupilsPage, CareerYouthProgramsStudentsPage, CareerYouthProgramsBeginnersPage, CareerYouthProgramsRegistration, CareerYouthProgramsPartners, CareerDetailProgramsPage, CareerGraduates, CareerContact, CareerAdvantages } from '@/views/Career/CareerYouthPrograms'
import Files from '@/views/Files'
import { SearchPage } from '@/views/SearchPage'
import { MediaLibrary, MediaLibraryDetail } from '@/views/MediaLibrary';
import { HistoryPage } from '@/views/HistoryPage'
import { VacancySection } from '@/views/global'
import { IndustrialTourismPage } from '@/views/IndustrialTourismPage'
import { ProductsIppPage } from '@/views/ProductsIppPage'
import { SiteMap } from '@/views/SiteMap'
import { Subscription } from '@/views/Subscription'

app.component('header-layout', HeaderLayout)
app.component('footer-layout', FooterLayout)
app.component('layout', Layout)
app.component('main-page', MainPage)
app.component('news', News)
app.component('news-detail', NewsDetail)
app.component('cv-form', CVForm)
app.component('vacancies-page', VacanciesPage)
app.component('vacancy-detail', VacancyDetail)
app.component('career-youth-programs-page', CareerYouthProgramsPage)
app.component('career-youth-programs-pupils-page', CareerYouthProgramsPupilsPage)
app.component('career-youth-programs-students-page', CareerYouthProgramsStudentsPage)
app.component('career-youth-programs-beginners-page', CareerYouthProgramsBeginnersPage)
app.component('career-youth-programs-registration', CareerYouthProgramsRegistration)
app.component('career-youth-programs-partners', CareerYouthProgramsPartners)
app.component('career-detail-programs-page', CareerDetailProgramsPage)
app.component('career-graduates', CareerGraduates)
app.component('career-contact', CareerContact)
app.component('career-advantages', CareerAdvantages)
app.component('history-page', HistoryPage)
app.component('page-404', Page404)
app.component('files', Files)
app.component('search-page', SearchPage)
app.component('aside-news-list', AsideNewsList)
app.component('media-library', MediaLibrary)
app.component('media-library-detail', MediaLibraryDetail)
app.component('vacancy-section', VacancySection)
app.component('industrial-tourism-page', IndustrialTourismPage)
app.component('products-ipp-page', ProductsIppPage)
app.component('site-map', SiteMap)
app.component('subscription', Subscription)
